<template>
  <div>
    <b-row class="mx-25 align-items-center">
      <h3 class="mr-50">
        <feather-icon size="20" icon="ArchiveIcon" />
        الحسابات البنكية
      </h3>
      <b-button
        @click="showNewModal"
        variant="success"
        class="ml-auto"
        v-can="{ slug: $route.meta.slug, action: 'C' }"
      >
        <feather-icon class="mx-25" icon="PlusIcon" />
        إضافة
      </b-button>
    </b-row>

    <hr />

    <b-row>
      <b-col cols="12">
        <data-table ref="accountsTable" ep="v2/bank-accounts" :fields="fields">
          <template #cell(is_available)="{ item }">
            {{ item.is_available ? "نعم" : "لا" }}
          </template>
          <template #cell(actions)="data">
            <b-dropdown variant="link" no-caret :right="true">
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                variant="primary"
                @click="showEditModal(data)"
                v-can="{ slug: $route.meta.slug, action: 'U' }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">تعديل</span>
              </b-dropdown-item>
              <b-dropdown-item
                variant="info"
                @click="openAccountDriver(data.item.id)"
              >
                <feather-icon icon="UserIcon" />
                <span
                  class="align-middle ml-50"
                  v-can="{ slug: 'ngo_account_managers', action: 'S' }"
                  >محركي الحساب</span
                >
              </b-dropdown-item>
              <b-dropdown-item
                variant="danger"
                @click="onDelete(data)"
                v-can="{ slug: $route.meta.slug, action: 'D' }"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">حذف</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </data-table>
      </b-col>
    </b-row>
    <account-drivers-modal
      :bankId.sync="bankId"
      v-model="accountDriversModal"
    />
    <b-modal
      centered
      title=" تعديل الحساب البنكي"
      cancel-title="إلغاء"
      ok-title="تعديل"
      class="edit-modal"
      id="account-edit"
      footer-class="removed"
      v-model="editModal"
      static
      no-close-on-backdrop
    >
      <b-card-text>
        <validation-observer ref="editForm">
          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12">
                <b-form-group label="اسم البنك">
                  <form-select
                    v-model="editForm.bank_id"
                    :dir="'rtl'"
                    :getOptionLabel="(x) => x.name_ar"
                    :reduce="(x) => x.id"
                    ep="v2/selects/banks"
                    rules="required"
                    disabled
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <form-input
                  v-model="editForm.branch_name"
                  label="اسم الفرع*"
                  rules="required|max:50"
                ></form-input>
              </b-col>

              <b-col cols="12">
                <form-input
                  v-model="editForm.account_no"
                  label="رقم الحساب*"
                  rules="required|max:50"
                ></form-input>
              </b-col>
              <b-col cols="12">
                <b-form-checkbox
                  variant="success"
                  v-model="editForm.is_available"
                  class="custom-control-success"
                >
                  مخصص للتبرع
                </b-form-checkbox>
              </b-col>
            </b-row>
            <hr />
            <b-row class="justify-content-end mx-25">
              <b-button class="mx-1" @click="editModal = false">الغاء</b-button>
              <save-btn
                @click="onUpdate"
                variant="primary"
                :loading="loading"
              ></save-btn>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-text>
    </b-modal>
    <b-modal
      centered
      title=" إضافة الحساب البنكي"
      class="edit-modal"
      id="account-new"
      footer-class="removed"
      v-model="newModal"
      static
      no-close-on-backdrop
    >
      <b-card-text>
        <validation-observer ref="addForm">
          <b-form @submit.prevent="onNew">
            <b-row>
              <b-col cols="12">
                <form-select
                  id="bank"
                  label="اسم البنك*"
                  v-model="editForm.bank_id"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x.id"
                  ep="v2/selects/banks"
                  name="البنك"
                  rules="required"
                />
              </b-col>
              <b-col cols="12">
                <form-input
                  v-model="editForm.branch_name"
                  label="اسم الفرع*"
                  id="branch"
                  rules="required|max:50"
                ></form-input>
              </b-col>
              <b-col cols="12">
                <form-input
                  v-model="editForm.account_no"
                  label="رقم الحساب*"
                  id="accountNumber"
                  rules="required|max:50"
                ></form-input>
              </b-col>
              <b-col cols="12">
                <b-form-checkbox
                  variant="success"
                  v-model="editForm.is_available"
                  class="custom-control-success"
                >
                  مخصص للتبرع
                </b-form-checkbox>
              </b-col>
            </b-row>
            <hr />
            <b-row class="justify-content-end mx-25">
              <b-button class="mx-1" @click="newModal = false">الغاء</b-button>
              <save-btn
                type="submit"
                variant="success"
                :loading="loading"
              ></save-btn>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
import { required } from "@validations";
import saveBtn from "@/components/loader-btn.vue";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BCardText,
  BCardTitle,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BForm,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BModal,
  BFormCheckbox,
} from "bootstrap-vue";

import { ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import DataTable from "@/components/data-table";
import formInput from "@/components/form-input";
import FormCleave from "@/components/FormCleave";
import formSelect from "@/components/form-select";
import { mapActions, mapGetters } from "vuex";
import accountDriversModal from "../../components/AccountDriversModal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    accountDriversModal,
    BTable,
    DataTable,
    BAvatar,
    formSelect,
    ValidationObserver,
    BBadge,
    BRow,
    BCol,
    saveBtn,
    BFormGroup,
    BCard,
    BCardText,
    BCardTitle,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BForm,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BModal,
    BFormCheckbox,
    vSelect,
    formInput,
    FormCleave,
  },
  data() {
    return {
      newModal: false,
      editModal: false,
      bankId: null,
      perPage: 10,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      accountDriversModal: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      required,
      editForm: {
        id: null,
        bank: null,
        branch: null,
        branch_name: null,
        account_number: null,
        is_available: false,
      },

      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        { key: "bank.name_ar", label: "اسم البنك", sortable: true },
        { key: "branch_name", label: "اسم فرع البنك", sortable: true },
        {
          key: "account_no",
          label: "رقم حساب البنك",
          sortable: true,
        },
        {
          key: "is_available",
          label: "هل الحساب مخصص للتبرع ؟",
        },
        { key: "actions", label: "الأوامر" },
      ],
    };
  },
  computed: {
    ...mapGetters("NgoProfile/BankAccounts", ["loading"]),
  },
  methods: {
    ...mapActions("NgoProfile/BankAccounts", [
      "editAccount",
      "addAccount",
      "deleteAccount",
    ]),
    openAccountDriver(id) {
      this.bankId = id;
      this.accountDriversModal = true;
    },
    showEditModal(data) {
      this.editForm.id = data.item.id;
      this.editForm.bank_id = data.item.bank.id;
      this.editForm.branch_name = data.item.branch_name;
      this.editForm.account_no = data.item.account_no;
      this.editForm.is_available = data.item.is_available === 1 ? true : false;
      this.$bvModal.show("account-edit");
    },
    showNewModal() {
      this.editForm = {
        is_available: false,
      };
      this.$bvModal.show("account-new");
    },
    async onNew() {
      await this.$refs.addForm.validate().then(async (success) => {
        if (success) {
          await this.addAccount(this.editForm);
          this.$refs.accountsTable.refreshTable();
          this.newModal = false;
        }
      });
    },

    async onUpdate() {
      await this.$refs.editForm.validate().then(async (success) => {
        if (success) {
          await this.editAccount({ id: this.editForm.id, form: this.editForm });
          this.$refs.accountsTable.refreshTable();
          this.editModal = false;
        }
      });
    },
    async onDelete(data) {
      this.$bvModal
        .msgBoxConfirm(
          "هل أنت متأكد من حذف الحساب؟ سيتم حذف محركين الحساب أيضاً.",
          {
            title: "تأكيد حذف الحساب",
            size: "sm",
            okVariant: "danger",
            okTitle: "تأكيد",
            cancelTitle: "إلغاء",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "جاري الحذف ...",
              icon: "Trash2Icon",
              variant: "info",
            },
          });
          if (value) {
            await this.deleteAccount(data.item.id);
            this.$refs.accountsTable.refreshTable();
          }
        });
    },
  },
};
</script>
